import { Injectable,ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { MenuController,NavParams,NavController,Events,Platform,AlertController } from 'ionic-angular';
import { SocialSharing } from '@ionic-native/social-sharing';
import { PageText } from '../pages/page-text/page-text'
import { PageSlider } from '../pages/page-slider/page-slider'
import { PageAudio } from '../pages/page-audio/page-audio'
import { Storagehelper } from '../providers/storagehelper'


import { LocalNotifications } from '@ionic-native/local-notifications';

/*
  Generated class for the Commontask provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class Commontask {
  public alertTitle;
  @ViewChild('mycontent') nav;
  
  public categoryDetail;
  public swedishMonths=['januari','februari','mars','april','maj','juni','juli','augusti','september','oktober','november','december'];
  constructor(public menuctrl:MenuController,public event:Events,public platform:Platform,public socialSharectrl:SocialSharing,public alertCtrl:AlertController) {
    console.log('Hello Commontask Provider');
    this.alertTitle="Snorkel";
    this.categoryDetail={category_title:"",category_id:-1};
  }

  openMenu(){
  	this.menuctrl.open();
  }


  confirmDelete(){
    return new Promise((resolve,reject)=>{
         let alert=this.alertCtrl.create({
          title:this.alertTitle,
          message:'Är du säker på att du vill ta bort?',
          buttons:[
                    {
                      text:'Nej',
                      role:'cancel',
                      handler:()=>{
                        resolve(false);
                      }
                    },{
                      text:'Ja',
                      handler:()=>{
                        resolve(true);
                      }
                    }
                  ]
      })
         alert.present();
    })
  }


  public unscheduleReminder(localnotifcation,reminderid){
    return localnotifcation.clear(reminderid);
  }


  gotopage(menuItem){
    menuItem.bckButtonAvailable=true;
  	this.event.publish("app:changePage",menuItem);

  }

  goback(){
    this.event.publish("app:goBack");
  }


  isDevice(){
    if(this.platform.is('core') || this.platform.is('mobileweb')) {
        return false;
      }else{
        return true;
      }
  }

  shareLink(pageDetail){
      var msg="Hej, jag vill tipsa dig om appen Snorkel. ";
      var sub="App suggestion";
      var link="https://play.google.com/store/apps/details?id=se.lul.dream";
      if(pageDetail.shareApp==1){

        link="http://109.74.12.180/snorkel/webapp/?taskid="+pageDetail.Id;
      }else{
        
        link="http://109.74.12.180/snorkel/webapp";
      }
        msg="Hej, jag vill tipsa dig om appen Snorkel. ";
        sub="Task suggestion";
        this.socialSharectrl.share(msg,sub,'',link).then(()=>{
          console.log("nice"); 
        })
      
    
  }

  getHeaderBackground(){

  }

  getCategoryByCategoryID(storageHelp:Storagehelper,navParams:NavParams){
      storageHelp.queryStorage("menuCategories",'category_id',navParams.get("categoryID")).then((data)=>{
        if(data!=undefined && data.length>0){
          this.categoryDetail=data[0];
        }
      });
    
  }

  askPlatform(){

     let alert=this.alertCtrl.create({
              title:"Mitt lugn",
              cssClass:"alert-settings",
              message:'Välj plattform för att dela app på',
              buttons:[{
                text:'Android',
                role:'null',
                handler:()=>{
                    var msg="Hej, jag vill tipsa dig om hur du kan hitta ditt lugn.";
                    var sub="App suggestion";
                    var link="https://play.google.com/store/apps/details?id=se.lul.dream";
                    this.socialSharectrl.share(msg,sub,'',link).then(()=>{
                      console.log("nice"); 
                    })
                }
              },
              {
                text:'IOS',
                role:'null',
                handler:()=>{
                    var msg="Hej, jag vill tipsa dig om hur du kan hitta ditt lugn.";
                    var sub="App suggestion";
                    var link="https://itunes.apple.com/us/app/mitt-lugn/id1067634331?mt=8";
                    this.socialSharectrl.share(msg,sub,'',link).then(()=>{
                      console.log("nice"); 
                    })
                }
              }]
            })
            alert.present();


  }


  checkIfBackgroundStatic(bgtitle){
    var currentstatic=[];
    var matchedImage="";
    var filteredMatch=currentstatic.filter((e,i)=>{
      return bgtitle.indexOf(e.image)!=-1
    });
    if(filteredMatch.length>0){
      return filteredMatch[0].class;
    }else{
      return false;
    }
  }


  public getFormattedDate(date){
      let newformattedDate=date.getDate()+" "+this.swedishMonths[date.getMonth()]+" "+date.getFullYear();
      return newformattedDate;
  }

}



// WEBPACK FOOTER //
// ./src/providers/commontask.ts